import {
    CustomReportFiltersParams,
    GetSustainabilityTotalEmissionsRequestParams,
    TotalEmissionsReportType,
    TotalEmissionsScope2Type,
} from '@/hooks'
import { getTimelineValue } from '@/components/common/Filter/TimelineFilter/utils'

export const processSustainabilityFilters = (
    filters: CustomReportFiltersParams
): GetSustainabilityTotalEmissionsRequestParams => {
    const { startDate, endDate } =
        'startDate' in filters && 'endDate' in filters
            ? { startDate: filters.startDate, endDate: filters.endDate }
            : getTimelineValue(filters.timeline)

    return {
        'nodeIds[]': filters.nodeIds.join(','),
        'commodityTypeIds[]': filters.commodityTypeIds?.join(','),
        'contractIds[]': filters.contractIds?.join(','),
        'tagIds[]': filters.tagIds?.join(','),
        'facilityIds[]': filters.facilityIds?.join(','),
        'meterIds[]': filters.meterIds?.join(','),
        startDate,
        endDate,
        type: filters.type as TotalEmissionsReportType,
        scope: filters.scope,
        scope2type: filters.scope2type as TotalEmissionsScope2Type | undefined,
    }
}
